import { ColorSystemOptions, CssVarsThemeOptions, SupportedColorScheme } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import { BreakpointsOptions, ShapeOptions } from "@mui/system";

import { BREAKPOINTS, COLOR, CSS_VARIABLE_PREFIX, FONT_FAMILY, SHAPE } from "./theme.constants";

const breakpoints: BreakpointsOptions = {
    values: {
        xs: BREAKPOINTS.XS,
        sm: BREAKPOINTS.SM,
        md: BREAKPOINTS.MD,
        lg: BREAKPOINTS.LG,
        xl: BREAKPOINTS.XL,
    },
};

const colorSchemes: Partial<Record<SupportedColorScheme, ColorSystemOptions>> = {
    light: {
        palette: {
            primary: {
                main: COLOR.PRIMARY,
            },
            text: {
                secondary: COLOR.TEXT,
                disabled: COLOR.GREY_500,
            },
            action: {
                disabled: COLOR.GREY_500,
            },
            divider: COLOR.GREY_500,
        },
    },
};

const typography: TypographyOptions = {
    fontFamily: FONT_FAMILY.MAIN,
};

const shape: ShapeOptions = {
    borderRadius: SHAPE.BORDER_RADIUS,
};

export const theme: CssVarsThemeOptions = {
    breakpoints,
    colorSchemes,
    cssVarPrefix: CSS_VARIABLE_PREFIX,
    shape,
    typography,
    spacing: (factor: number) => `${0.5 * factor}rem`,
};
